import React, { useState, useEffect } from "react";
import { createGroup, getAllGroups } from "../utils/groupApi";
import { useNavigate } from "react-router-dom";

export default function CreateGroup() {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [parentId, setParentId] = useState("");
  const [groups, setGroups] = useState([]);

  const nav = useNavigate();

  useEffect(() => {
    loadGroups();
  }, []);

  const loadGroups = async () => {
    try {
      const res = await getAllGroups();
      setGroups(res.data);
    } catch (err) {
      console.error("Failed to load groups", err);
    }
  };

  const submit = async () => {
    if (!name.trim()) return alert("Group name required");

    try {
      await createGroup({
        name,
        description,
        parentId: parentId || null
      });

      nav("/groups");
    } catch (err) {
      console.error(err);
      alert("Failed to create group");
    }
  };

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h2 className="text-xl font-bold mb-4">
        Create Playlist / Sub Playlist
      </h2>

      <input
        placeholder="Group name"
        className="border p-2 w-full mb-3 rounded"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <textarea
        placeholder="Description"
        className="border p-2 w-full mb-3 rounded"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      {/* 🔥 Parent Selector */}
      <select
        className="border p-2 w-full mb-3 rounded"
        value={parentId}
        onChange={(e) => setParentId(e.target.value)}
      >
        <option value="">No Parent (Create Root Group)</option>
        {groups.map((group) => (
          <option key={group._id} value={group._id}>
            {group.name}
          </option>
        ))}
      </select>

      <button
        onClick={submit}
        className="bg-black text-white px-4 py-2 rounded w-full"
      >
        Create
      </button>
    </div>
  );
}
